<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount, ref, computed } from "vue";
import { useStore } from "vuex";
import storeData from "../store";
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ProfileCard from "./components/ProfileCard.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from "../axios";
import { useVuelidate } from '@vuelidate/core';
import { required, email, sameAs, minLength } from '@vuelidate/validators';


const body = document.getElementsByTagName("body")[0];
const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.add("profile-overview");
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});



const url = ref(process.env.VUE_APP_API_URL);
const name = ref(storeData.state.auth.user.name);
const userEmail = ref(storeData.state.auth.user.email);
const profile = ref(storeData.state.auth.user.profile_picture_url);

const password = ref("");
const confirmPassword = ref("");

const isProfileLoading = ref(false);
const isPasswordLoading = ref(false);

const rules = computed(() => {
  return {
    userEmail: { required, email },
    name: { required }
  }
});

const $v = useVuelidate(rules, {
  userEmail,
  name,
});

const passwordRules = computed(() => {
  return {
    password: { required, minLength: minLength(6) },
    confirmPassword: { required, sameAs: sameAs(password) }
  }
});
const $vPassword = useVuelidate(passwordRules, {
  password,
  confirmPassword,
});



const updateProfile = () => {
  $v.value.$touch();
  if ($v.value.$invalid) {
    return;
  }
  isProfileLoading.value = true;
  axios
    .post(url.value + "api/updateProfile", {
      name: name.value,
      email: userEmail.value,
    })
    .then((res) => {
      isProfileLoading.value = false;
      store.commit("setSuccessNotification", "Profile updated successfully");
      store.commit("setErrorNotification", null);
      setTimeout(() => {
        store.commit("clearNotifications");
      }, 3000);
      console.log(res);
      store.commit("auth/setUser", res.data.user);
    }).catch((error) => {
      isProfileLoading.value = false;
      console.log(error);
      if (error.response?.data && error.response?.data.error) {
        store.commit("setErrorNotification", error.response.data.error);
        store.commit("setSuccessNotification", null);
        setTimeout(() => {
          store.commit("clearNotifications");
        }, 3000);
      }
    });
};

const updatePassword = () => {
  $vPassword.value.$touch();
  if ($vPassword.value.$invalid) {
    return;
  }
  isPasswordLoading.value = true;
  axios
    .post(url.value + "api/changePassword", {
      password: password.value,
      password_confirmation: confirmPassword.value,
    })
    .then((res) => {
      isPasswordLoading.value = false;
      password.value = "";
      confirmPassword.value = "";
      $vPassword.value.$reset();
      store.commit("setSuccessNotification", "Password updated successfully");
      store.commit("setErrorNotification", null);
      setTimeout(() => {
        store.commit("clearNotifications");
      }, 3000);
      console.log(res);
    }).catch((error) => {
      isPasswordLoading.value = false;
      console.log(error);
      if (error.response?.data && error.response?.data.error) {
        store.commit("setErrorNotification", error.response.data.error);
        store.commit("setSuccessNotification", null);
        setTimeout(() => {
          store.commit("clearNotifications");
        }, 3000);
      }
    });
};

</script>

<template>
  <div class="py-4 ps-1 container-fluid overflow-hidden">

    <div class="row py-4 mt-5">

      <div class="col-md-4">
        <profile-card :email="userEmail" :name="name" :profile="profile"/>
      </div>
       




      <div class="col-md-8">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Edit Profile</p>
              <!-- <argon-button color="success" size="sm" class="ms-auto"
                  >Settings</argon-button
                > -->
            </div>
          </div>
          <div class="card-body">
            <p class="text-uppercase text-sm">Admin Information</p>
            <div class="row">
              <!-- <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Username</label
                  >
                  <argon-input type="text" v-model="storeData.}}" />
                </div> -->
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Name</label>
                <input class="form-control" type="text" v-model="name" :class="{ 'is-invalid': $v.name.$error }" />
                <p class="text-danger" v-if="$v.name.$error">
                  <span v-if="!$v.name.$pending && !$v.name.$model">Name is required.</span>
                </p>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Email</label>
                <input type="email" v-model="userEmail" class="form-control"
                  :class="{ 'is-invalid': $v.userEmail.$error }" />
                <p class="text-danger" v-if="$v.userEmail.$error">
                  <span v-if="!$v.userEmail.$pending && !$v.userEmail.$model">Email is required.</span>
                  <span v-if="!$v.userEmail.$pending && $v.userEmail.$model && !$v.userEmail.$params">Invalid email
                    format.</span>
                </p>
              </div>
              <!-- <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Last name</label
                  >
                  <argon-input type="text" value="Lucky" />
                </div> -->
            </div>
            <div class="row">
              <div class="col-12 text-end pt-3">
                <argon-button size="sm" class="ms-auto btn-bg" @click="updateProfile"
                  :disabled="isProfileLoading">Save</argon-button>
              </div>
            </div>


          </div>
        </div>
        <div class="card mt-3">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center">
              <p class="mb-0">Change Password</p>

            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">New Password</label>
                <input type="password" class="form-control" v-model="password"
                  :class="{ 'is-invalid': $vPassword.password.$error }" />
                <p class="text-danger" v-if="$vPassword.password.$error">
                  <span v-if="!$vPassword.password.$pending && !$vPassword.password.$model">Password is required.</span>
                  <span
                    v-if="!$vPassword.password.$pending && $vPassword.password.$model && !$vPassword.password.$params">Password
                    must be at least 6 characters long.</span>
                </p>
              </div>
              <div class="col-md-6">
                <label for="example-text-input" class="form-control-label">Confirm Password</label>
                <input class="form-control" type="password" v-model="confirmPassword"
                  :class="{ 'is-invalid': $vPassword.confirmPassword.$error }" />
                <p class="text-danger" v-if="$vPassword.confirmPassword.$error">
                  <span v-if="!$vPassword.confirmPassword.$pending && !$vPassword.confirmPassword.$model">Confirm
                    Password is required.</span>
                  <span
                    v-if="!$vPassword.confirmPassword.$pending && $vPassword.confirmPassword.$model && !$vPassword.confirmPassword.$params">Passwords
                    do not match.</span>
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-12 text-end pt-3">
                <argon-button size="sm" class="ms-auto btn-bg" @click="updatePassword"
                  :disabled="isPasswordLoading">Save</argon-button>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

  </div>
</template>
